<template>
  <div>
    <!-- 发送分公司 -->
    <template v-if="sendBranchWindow.visible">
      <el-dialog
        v-if="sendBranchSelectObject === 2"
        v-el-drag-dialog
        :visible.sync="sendBranchWindow.visible"
        :title="$t('SeaExport.ConsignationSI')"
        width="550px"
        :close-on-click-modal="false"
      >
        <el-form label-width="96px" label-position="right">
          <el-form-item label-width="0">
            <span style="color: #000000;font-size: 14px;">{{ $t('CargoMsg.Cargo_EntrustedReceiveInfo') }}</span>
          </el-form-item>
          <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : $t('SeaExport.Operation')">
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
              style="width: 200px"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
          <!--自定义业务类型（同租户 且 出口转进口 场景）-->
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :method-params="{type:'SI', grade: 0, active: true}"
              :tag-name="isZh?'name':'englishName'"
              style="width: 200px"
              @parentCallBack="p=>{sendBranchWindow.customJobType=p.value}"
            />
          </el-form-item>
        </el-form>
        <el-form label-width="40px" :inline="true" label-position="right">
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ $store.getters.currentOffice.chineseName }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ sendBranchWindow.title }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consignee" disabled style="width: 200px">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeTarget" style="width: 200px" @change="onConsigneeTargetChange">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
              <el-option :label="$t('SeaExport.ConsignationCompany')" value="customer" />
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consigneeDetail" disabled style="width: 200px">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeDetailTarget" style="width: 200px" @change="onConsigneeDetailTargetChange">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
              <el-option :label="$t('SeaExport.ShipperDetail')" value="shipperDetail" />
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;margin-left:40px">{{ $t('queryJob.NoteConsigneeCustomerExportImport') }}</div>
        <div slot="footer" style="display: flex;justify-content: space-between;">
          <el-checkbox v-model="sendBranchWindow.checkConsigneeDefault" style="color: #000000" @change="onCheckConsigneeDefaultChange">{{ $t('queryJob.SetAsDefaultExportInfo') }}</el-checkbox>
          <div>
            <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
            <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        v-else
        v-el-drag-dialog
        :visible.sync="sendBranchWindow.visible"
        :title="sendBranchWindow.title"
        width="360px"
        :close-on-click-modal="false"
      >
        <el-form label-width="96px" label-position="right">
          <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : $t('SeaExport.Operation')">
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
          <!--自定义业务类型（同租户 且 出口转进口 场景）-->
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_CutomJobType"
              filterable
              :method-params="{type:'SI', grade: 0, active: true}"
              :tag-name="isZh?'name':'englishName'"
              @parentCallBack="p=>{sendBranchWindow.customJobType=p.value}"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <el-dialog
      :visible.sync="checkingDialog.visible"
      :title="$t('SystemMaintenance.ExportToImport')"
      width="820px"
      :close-on-click-modal="false"
    >
      <div class="check-tip">
        <img :src="trueIcon" style="margin-bottom: 15px;">
        <div>{{ $t('queryJob.BatchProgressPleaseReferBelow') }}</div>
      </div>
      <el-table :data="checkingDialog.rowData" :height="310">
        <el-table-column prop="serialNumber" :label="$t('CargoMsg.Cargo_SerialNo')" width="200" align="center" show-overflow-tooltip />
        <el-table-column prop="jobNo" :label="$t('Message.OddNumbers')" width="300" align="center" show-overflow-tooltip />
        <el-table-column prop="state" :label="$t('CargoMsg.Cargo_Status')" width="295" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <div v-if="row.state === 'checking'"><img :src="loadingIcon"></div>
            <div v-else-if="row.state === 'success'"><img :src="acceptIcon"></div>
            <div v-else><img :src="rejectIcon"></div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="checkingDialog.visible=false">{{ $t('Message.Close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import trueIcon from '@/assets/true-x32.png'
import acceptIcon from '@/assets/accept-x16.png'
import rejectIcon from '@/assets/reject-x16.png'
import loadingIcon from '@/assets/loading-x16.png'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import { queryCompany } from '@/api/company'
import { getUserDefaultDepartment } from '@/api/user'
import { getOfficeByUuid } from '@/api/office'
import { stringToNumArray } from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { checkingConsignationJob } from '@/api/seaExport/seaExportJob'
import { LOG_SE_SEA_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { createImportByExportJob } from '@/api/seaExport/seaExportJob'

export default {
  name: 'BatchExportToImportWindow',
  components: { CargoAdvanceSelect, cargoUserSelect },
  data() {
    return {
      trueIcon,
      acceptIcon,
      rejectIcon,
      loadingIcon,
      selectTypeNames: TYPE_NAMES,
      isCopySellingCharge: false,
      overwriteJobRefNoBySEconvertSI: false,
      chargeSyncNeedConfirm: false,
      sendBranchSelectObject: 0,
      allJobs: [], // 所有job
      masterJobSlavesMap: new Map(), // 主票与小票的映射
      jobs: [], // 需处理的jobs
      sendBranchWindow: {
        opNotNull: false, // 控制操作显示且必填
        visible: false,
        office: {},
        title: this.$t('SeaExport.SelectAction'),
        items: [{
          selectObject: 0,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        }],
        consigneeTarget: '',
        consigneeDetailTarget: '',
        checkConsigneeDefault: false, // 将本次内容设置为默认转出口信息
        customJobType: null // 自定义业务类型
      },
      checkingDialog: {
        visible: false,
        rowData: []
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    location() {
      return LOG_SE_SEA_BOOKING.code
    }
  },
  methods: {
    async onShow(rows) {
      this.isCopySellingCharge = Number(cache.config.get('isCopySellingCharge')) === 1
      this.overwriteJobRefNoBySEconvertSI = Number(cache.config.get('OverwriteJobRefNoBySEconvertSI')) === 1
      this.chargeSyncNeedConfirm = Number(cache.config.get('ChargeSyncNeedConfirm')) === 1
      const masterJobKeys = rows.filter(row => row.masterFlag).map(row => row.uuid)
      const masterJobSlavesMap = new Map()
      const jobs = []
      for (const row of rows) {
        // 排除主票下的小票，避免重复处理
        if (masterJobKeys.includes(row.lclMasterUuid)) {
          let slaves = masterJobSlavesMap.get(row.lclMasterUuid)
          if (!slaves) {
            slaves = []
            masterJobSlavesMap.set(row.lclMasterUuid, slaves)
          }
          slaves.push(row)
          continue
        }
        jobs.push(row)
      }
      const destinationAgentSet = new Set()
      for (const job of jobs) {
        destinationAgentSet.add(job.destinationAgent)
      }
      if (destinationAgentSet.size > 1) {
        this.$message.warning(this.$t('queryJob.BatchProcessingForTheReselect'))
        return
      }
      const company = await Company.getCompanyById(jobs[0].destinationAgent)
      if (!(company && company.linkedBranchId > 0)) {
        this.$message.warning(this.$t('queryJob.TheDestinationPortAgentEmpty'))
        return
      }
      const office = await Office.getOfficeById(company.linkedBranchId)
      if (!office) {
        this.$message.warning(this.$t('queryJob.TheThePortAgentExist'))
        return
      }
      this.readSendBranchSelectObject()
      this.allJobs = rows
      this.masterJobSlavesMap = masterJobSlavesMap
      this.jobs = jobs
      this.sendBranchWindow.office = office
      this.sendBranchWindow.title = office.chineseName
      this.sendBranchWindow.checkConsigneeDefault = LocalStorageUtilsNew.getConfiguration('SE_checkConsigneeDefault') || false
      if (this.sendBranchWindow.checkConsigneeDefault) {
        this.sendBranchWindow.consigneeTarget = LocalStorageUtilsNew.getConfiguration('SE_consigneeTargett', 'string') || 'consignee'
        this.sendBranchWindow.consigneeDetailTarget = LocalStorageUtilsNew.getConfiguration('SE_consigneeDetailTarget', 'string') || 'consigneeDetail'
      } else {
        this.sendBranchWindow.consigneeTarget = 'consignee'
        this.sendBranchWindow.consigneeDetailTarget = 'consigneeDetail'
      }
      this.sendBranchWindow.customJobType = null
      this.sendBranchWindow.visible = true
    },
    readSendBranchSelectObject() {
      this.sendBranchWindow.items = []
      const temArr = stringToNumArray(cache.config.get('SendBranchSelectObject'))
      let arr = []
      this.sendBranchWindow.opNotNull = false
      for (let temp of temArr) {
        if (temp === 3) { // 3控制操作显示并必填
          this.sendBranchWindow.opNotNull = true
          temp = 1
        }
        arr.push(temp)
      }
      if (arr.includes(2)) {
        this.sendBranchSelectObject = 2
        arr = [0, 1]
      } else {
        // 1 控制操作显示， 3控制操作显示并必填
        this.sendBranchSelectObject = arr[0] || 0
      }
      for (const selectObject of arr) {
        this.sendBranchWindow.items.push({
          selectObject,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        })
      }
    },
    // 销售change事件
    async userId_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        if (item.selectObject === 0) {
          await getUserDefaultDepartment({
            category: 'role',
            shape: 'csr',
            userId: userId
          }).then(res => this.getDefaultCsrResult(res, item))
        } else {
          const office = this.sendBranchWindow.office
          if (office) {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId,
              officeId: office.officeId
            }).then(res => this.getDefaultDeptResult(res, item))
          } else {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId
            }).then(res => this.getDefaultDeptResult(res, item))
          }
        }
      } else {
        item.departmentId = 0
        item.userId = 0
      }
    },
    // 操作部门
    getDefaultDeptResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res, item))
        } else {
          this.officeLoadHandler({ data: dep.office }, item)
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 加载csr加载dep后加载office后更新业务的客服分公司
    officeLoadHandler(event, item) {
      const office = event.data
      if (office) {
        item.departmentOfficeId = office.officeId
      } else {
        item.departmentOfficeId = 0
      }
    },
    onCheckConsigneeDefaultChange() {
      LocalStorageUtilsNew.setConfiguration('SE_checkConsigneeDefault', this.sendBranchWindow.checkConsigneeDefault)
      if (this.sendBranchWindow.checkConsigneeDefault) {
        this.onConsigneeTargetChange()
        this.onConsigneeDetailTargetChange()
      } else {
        LocalStorageUtilsNew.removeConfiguration('SE_consigneeTargett')
        LocalStorageUtilsNew.removeConfiguration('SE_consigneeDetailTarget')
      }
    },
    onConsigneeTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SE_consigneeTargett', this.sendBranchWindow.consigneeTarget)
      }
    },
    onConsigneeDetailTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SE_consigneeDetailTarget', this.sendBranchWindow.consigneeDetailTarget)
      }
    },
    // 发送分公司保存业务
    async enterSendHandler() {
      if (this.sendBranchWindow.opNotNull && this.sendBranchWindow.items && this.sendBranchWindow.items.length > 0) {
        for (const itemElement of this.sendBranchWindow.items) {
          if (itemElement.userId === 0 && itemElement.selectObject === 1) {
            this.$message.warning(this.$t('SeaExport.PleaseSelectAction'))
            return
          }
        }
      }
      this.sendBranchWindow.visible = false
      const checkingData = []
      let serialNumber = 1
      for (const job of this.jobs) {
        const checkingItem = {
          serialNumber: serialNumber++,
          uuid: job.uuid,
          jobNo: job.jobNo
        }
        if (job.masterFlag || !(job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code)) {
          checkingItem.state = 'checking'
          checkingItem.message = ''
          if (!job.eta) {
            checkingItem.state = ''
            checkingItem.message = this.$t('SeaExport.DateOfArrival2') + this.$t('CargoMsg.Cargo_CanNotEmpty')
          }
        } else {
          checkingItem.state = ''
          checkingItem.message = this.$t('queryJob.NotForReExport')
        }
        checkingData.push(checkingItem)
        // 处理主票的关联小票
        if (this.masterJobSlavesMap.has(job.uuid)) {
          const slaves = this.masterJobSlavesMap.get(job.uuid)
          for (const slave of slaves) {
            checkingData.push({
              serialNumber: serialNumber++,
              uuid: slave.uuid,
              jobNo: slave.jobNo,
              state: checkingItem.state,
              message: checkingItem.message ? '-' : ''
            })
          }
        }
      }
      this.checkingDialog.rowData = checkingData
      this.checkingDialog.visible = true
      this.executeBatchTask()
    },
    executeBatchTask() {
      // 构建通用参数
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = this.sendBranchWindow.items[0].selectObject === 0 ? 'csr' : 'op' // shape
      item.anyBool = this.isCopySellingCharge // isCopySellingCharge
      item.anyInteger = this.sendBranchWindow.items[0].departmentId // departmentId
      item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId // departmentOfficeId
      item.anyInteger2 = this.sendBranchWindow.items[0].userId // userId
      // item.anyInteger3 = this.partner.cmpIdx // cmpIdx
      item.anyInteger4 = this.sendBranchWindow.office.officeId // officeId
      // item.anyStr1 = this.job.uuid
      item.anyBool1 = this.overwriteJobRefNoBySEconvertSI
      item.anyBool2 = this.chargeSyncNeedConfirm
      item.location = this.location
      if (this.sendBranchWindow.items.length > 1) {
        const item2 = this.sendBranchWindow.items[1]
        item.anyStr2 = item2.selectObject === 0 ? 'csr' : 'op' // shape
        item.anyInteger5 = item2.departmentId // departmentId
        item.anyInteger6 = item2.departmentOfficeId // departmentOfficeId
        item.anyInteger7 = item2.userId // userId
      }
      const excludeFileds = []
      for (const item of this.sendBranchWindow.items) {
        if (item.userId) {
          excludeFileds.push(item.selectObject)
        }
      }
      // 自定义业务类型
      item.customJobType = this.sendBranchWindow.customJobType

      for (const job of this.jobs) {
        const row = this.checkingDialog.rowData.find(item => item.uuid === job.uuid)
        if (!row || row.state !== 'checking') {
          continue
        }
        this.executeSingleTask({ ...item }, job)
      }
    },
    async executeSingleTask(params, job) {
      try {
        let res = await checkingConsignationJob(job.uuid)
        if (res.data !== 1) {
          this.updateCheckingItem(job.uuid, '', this.$t('Message.CheckingConsignation'))
          return
        }
        if (this.sendBranchWindow.office.officeId === job.opOffice) {
          this.updateCheckingItem(job.uuid, '', this.$t('queryJob.TheNotMeetTheConversion'))
          return
        }
        // 检索属于订舱代理所属分公司的合作伙伴ID
        res = await queryCompany(1, job.opOffice)
        if (!res.data || res.data.length === 0) {
          this.updateCheckingItem(job.uuid, '', this.$t('Message.TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI'))
          return
        }
        const partner = res.data[0]
        params.anyInteger3 = partner.cmpIdx // cmpIdx
        params.anyStr1 = job.uuid
        if (this.sendBranchSelectObject === 2) {
          params.consigneeTarget = this.sendBranchWindow.consigneeTarget
          params.consigneeDetailTarget = this.sendBranchWindow.consigneeDetailTarget
          if (this.sendBranchWindow.consigneeTarget === 'customer') {
            if (job.masterFlag) {
              res = await new SeaExportJob(job).getLclSlaves()
              let message = ''
              if (job.lclSlaves && job.lclSlaves.length > 0) {
                for (const lclSlave of job.lclSlaves) {
                  const company = lclSlave.consigneeId > 0 ? await Company.getCompanyById(lclSlave.consigneeId) : null
                  if (company) {
                    if (!company.customer) {
                      message = `【${lclSlave.jobNo}】` + this.$t('queryJob.ConsigneeCustomerNotExist')
                      break
                    }
                  } else {
                    message = `【${lclSlave.jobNo}】` + this.$t('queryJob.RecipientNotExist')
                    break
                  }
                }
              }
              if (message) {
                this.updateCheckingItem(job.uuid, '', message)
                return
              }
            } else {
              const company = job.consigneeId > 0 ? await Company.getCompanyById(job.consigneeId) : null
              if (company) {
                if (!company.customer) {
                  this.updateCheckingItem(job.uuid, '', this.$t('queryJob.ConsigneeCustomerNotExist'))
                  return
                }
              } else {
                this.updateCheckingItem(job.uuid, '', this.$t('queryJob.RecipientNotExist'))
                return
              }
            }
          }
        }
        await createImportByExportJob(params)
        this.updateCheckingItem(job.uuid, 'success', '')
      } catch (err) {
        this.updateCheckingItem(job.uuid, 'fail', '')
      }
    },
    updateCheckingItem(uuid, state, message) {
      const row = this.checkingDialog.rowData.find(item => item.uuid === uuid)
      if (!row) {
        return
      }
      row.state = state
      row.message = message
      // 处理主票的关联小票
      if (this.masterJobSlavesMap.has(row.uuid)) {
        const slaves = this.masterJobSlavesMap.get(row.uuid)
        for (const slave of slaves) {
          const item = this.checkingDialog.rowData.find(item => item.uuid === slave.uuid)
          if (!item) {
            continue
          }
          item.state = state
          item.message = message ? '-' : ''
        }
      }
      this.checkingDialog.rowData = [...this.checkingDialog.rowData]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    border: 1px solid #DCDFE6;
    .el-table__header-wrapper {
      th.el-table__cell {
        background: #F2F2F2;
      }
    }
  }
}
.check-tip {
  margin: 5px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
